import { Component, Inject, OnInit } from "@angular/core";
import {
   MAT_DIALOG_DATA,
   MatDialog,
   MatDialogRef
} from "@angular/material/dialog";
import { Store } from "@ngrx/store";
import { PortalAppState } from "../../../store/reducer";
import { TranslateService } from "@ngx-translate/core";
import {
  Attachment,
  CommonState,
  CurrentState,
  DeleteAttachmentSuccessAction,
  LoadAnimalByIdAction,
  LoadProfitLossByIdAction,
  LoadItemByIdAction,
  LoadMarkerAction,
  ReloadTaskAction,
  ServicesCommon,
  SetSelectedAttachmentAction,
  UpdateAttachmentAction,
  UpdateAttachmentsAction
} from "common-lib";
import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { catchError, filter, map } from "rxjs/operators";
import { DialogComponent } from "../../../components/dialog/dialog.component";
import {AttachmentType} from "../../../../../../pastureProFECommon/projects/common-lib/src/lib/model";
import {FileDownloadService} from "../../../services/file-download.service";
import {ClearErrorMessage} from "../../../../../../pastureProFECommon/projects/common-lib/src/lib/store/errors";
import {LoadLeaseByIdAction} from "../../../../../../pastureProFECommon/projects/common-lib/src/lib/store/leases";

@Component({
  selector: 'attachment-page',
  templateUrl: './attachment.page.html',
  styleUrls: ['./attachment.page.scss']
})
export class AttachmentPage implements OnInit {
  selectedAttachments: Observable<Attachment[]>;
  description = '';
  private file: any;
  private imageSrc: string | ArrayBuffer;
  private attachmentType: AttachmentType;
  attachmentTypes: AttachmentType[];
  wip: boolean = false;

  constructor(protected store: Store<PortalAppState>,              public dialogRef: MatDialogRef<AttachmentPage>,
              @Inject(MAT_DIALOG_DATA) public data: {},

              private ts: TranslateService,
              private servicesCommon: ServicesCommon,
              public dialog: MatDialog,
              private translateService: TranslateService,
              private http: HttpClient,
              private currentState: CurrentState<CommonState>,
              private fileDownloadService: FileDownloadService) {

  }

  ngOnInit(): void {
    this.selectedAttachments = this.store.select(state => state.attachments.attachments).pipe(filter(a => !!a), map(a => {
      return [].concat(a.map(b => {
        return {...b};
      }));
    }));
    this.attachmentTypes = this.currentState.snapshot.attachments.attachmentTypes;
  }

  attachmentClicked(attachment: any) {
    console.log('clicked');
    console.log(attachment);
  }

  addAttachment() {
    console.log('addAttachment clicked');
  }

  deleteAttachment(attachment: Attachment) {
    console.log('clicked');
    console.log(attachment);
    const type = this.currentState.snapshot.attachments.type;
    const moduleEntityId = this.currentState.snapshot.attachments.id;
    this.http.delete(
      environment.backend + `/private/attachments/${attachment.id}`,
      {headers: this.servicesCommon.getAuthHeaders()}
    ).pipe(catchError(error => {
      console.error(error);
      return of(null);
    })).subscribe((response: number) => {
      if (!!response) {
        let attachmentsAfterDelete = this.currentState.snapshot.attachments.attachments.filter(a => a.id != response);
        console.log('attachmentsAfterDelete');
        console.log(attachmentsAfterDelete);
        this.store.dispatch(new UpdateAttachmentsAction(attachmentsAfterDelete));
        this.store.dispatch(new SetSelectedAttachmentAction(null));
        let payload = {
          attachmentId: response,
          type: type as any,
          moduleEntityId: +moduleEntityId
        };
        this.store.dispatch(new DeleteAttachmentSuccessAction(payload));
        this.reloadRelatedModuleEntity();
        this.close(null, attachment);
      }
    });
  }

  updateAttachment(attachment: Attachment) {
    console.log('Update attachment clicked');
    console.log(attachment)
    let request = {description: attachment.description};
    this.http.put(
      environment.backend + `/private/attachments/${attachment.id}`,
      request,
      {headers: this.servicesCommon.getAuthHeaders()}
    ).pipe(catchError(error => {
      console.error(error);
      return of(null);
    })).subscribe((response: Attachment) => {
      if (!!response) {
        this.currentState.snapshot.attachments.attachments.map(a => {
          if (a.id == response.id) {
            return response;
          }
          return a;
        });
        this.store.dispatch(new UpdateAttachmentAction(response));
        this.reloadRelatedModuleEntity();
      }
    });
  }

  close(newAttachment: Attachment = null, deletedAttachment: Attachment = null) {
    this.dialogRef.close({newAttachment, deletedAttachment});
  }

  private reloadRelatedModuleEntity() {
    const type = this.currentState.snapshot.attachments.type;
    const moduleEntityId = this.currentState.snapshot.attachments.id;
    console.log('moduleEntityId');
    console.log(moduleEntityId);
    if (!moduleEntityId) {
      return;
    }
    console.log('reloadRelatedModuleEntity called');
    if (type == 'animal' as 'livestock/profitloss/expense' | 'livestock/animal' | 'task') {
      // id = this.currentState.snapshot.livestock.selectedAnimal;
      this.store.dispatch(new LoadAnimalByIdAction(moduleEntityId));
    } else if (type == 'task' as 'livestock/profitloss/expense' | 'livestock/animal' | 'task') {
      // id = this.currentState.snapshot.tasks.selectedTask.id;
      this.store.dispatch(new ReloadTaskAction(moduleEntityId));
    } else if (type == 'profit_loss' as 'livestock/profitloss/expense' | 'livestock/animal' | 'task') {
      // id = this.currentState.snapshot.livestock.selectedProfitLoss;
      this.store.dispatch(new LoadProfitLossByIdAction(moduleEntityId));
    } else if (type == 'item' as 'livestock/profitloss/expense' | 'livestock/animal' | 'task') {
      // id = this.currentState.snapshot.finance.selectedItem;
      this.store.dispatch(new LoadItemByIdAction(moduleEntityId));
    } else if (type == 'marker' as 'livestock/profitloss/expense' | 'livestock/animal' | 'task') {
      // id = this.currentState.snapshot.finance.selectedItem;
      this.store.dispatch(new LoadMarkerAction(moduleEntityId));
    } else if (type == 'lease' as 'livestock/profitloss/expense' | 'livestock/animal' | 'task' ) {
      this.store.dispatch(new LoadLeaseByIdAction({leaseId: moduleEntityId}));
    }
  }

  save() {
    const moduleEntityId = !!this.currentState.snapshot.attachments.id ? this.currentState.snapshot.attachments.id : -1;
    // if (!moduleEntityId) {
    //   this.close(this.file);
    //   return;
    // }
    console.log('moduleEntityId: ' + moduleEntityId);
    this.wip = true;
    const formData = new FormData();
    formData.append("file", this.file);
    formData.append("notes", this.description);
    formData.append("attachmentTypeId", String(this.attachmentType.id));
    const ranchId = this.currentState.snapshot.ranches.selectedRanchId;
    const type = this.currentState.snapshot.attachments.type;
    const path = `/private/attachments/upload/ranch/${ranchId}/module/${type}/${moduleEntityId}`;
    const url = environment.backend + path;
    const token = this.currentState.snapshot.user.token;
    const headersConst = {
      'Authorization': token, 'Accept-Language': 'en'
    };
    const options = {
      headers: headersConst
    };
    console.log('formData');
    console.log(formData);
    console.log('url');
    console.log(url);
    const upload$ = this.http.post(url, formData, options);
    upload$.pipe(catchError(error => {
      console.error(error);
      this.wip = false;
      return of(null);
    })).subscribe(r => {
      console.log(r);
      if (!!r) {
        this.wip = false;
        this.showSuccessDialog(this.translateService.instant('DIALOG.MSG.ATTACHMENT_UPLOAD_SUCCESS'), r);
      }
    });
  }

  showSuccessDialog(msg: string = null, uploadedAttachment) {
    let title = this.translateService.instant('DIALOG.TITLE.SUCCESS');
    let message = !msg ? this.translateService.instant('DIALOG.MSG.ATTACHMENT_UPLOAD_SUCCESS') : msg;
    let closeLabel = this.translateService.instant('BUTTON.CLOSE');

    const dialogRef = this.dialog.open(DialogComponent, {
      panelClass: "success-dialog",
      height: '300px',
      width: '300px',
      data: {
        header: title,
        content: message,
        primaryBtnLabel: closeLabel,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.reloadRelatedModuleEntity();
      this.close(uploadedAttachment);
    });

  }

  onFileSelected(event) {
    this.file = event.target.files[0];
    const fileExtension = this.file.name.split('.').pop();
    this.attachmentType = this.attachmentTypes.filter(attachmentType => attachmentType.extension === fileExtension)[0];
    if (!this.attachmentType) {
      this.wip = true;
      this.showErrorDialog();
    }
    const reader = new FileReader();
    reader.onload = e => this.imageSrc = reader.result;
    reader.readAsDataURL(this.file);

  }

  async downloadAttachment(attachment: Attachment) {
    this.fileDownloadService.downloadFile(attachment.downloadUrl, attachment.path);
  }

  isImage(attachment: Attachment): boolean {
    return attachment.attachmentType.type === 'image';
  }


  descriptionChanged(event: Event) {
    console.log(event);
  }

  showErrorDialog() {
    let title = this.translateService.instant('ERROR.DIALOG_TITLE');
    let msg = this.translateService.instant('ERROR.FILE_TYPE_UNSUPPORTED');
    let closeLabel = this.translateService.instant('BUTTON.CLOSE');

    const dialogRef = this.dialog.open(DialogComponent, {
      panelClass: "error-dialog",
      height: '300px',
      width: '300px',
      data: {
        header: title,
        content: msg,
        primaryBtnLabel: closeLabel,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.store.dispatch(new ClearErrorMessage());
    });

  }
}
